import { actionCreatorFactory } from "typescript-fsa";
import { userdata } from "../typing/table_typing";


const actionCreator = actionCreatorFactory("TripleTopVuln");

 const resetData = actionCreator<{data:userdata[]}>("TRIPLETOPVULN_RESETDATA");

 export const TableThingyActions = { resetData}


